export enum UserValidationAction {
    AcceptTerms,
    BalanceForm,
    CampaignForm,
    ContactSettings,
    GeneralSettings,
    GeneralSettingsHash,
    Login,
    PhysicalSettings,
    Registration,
    Reset,
    SecuritySettings,
    UsergroupEmployeeUpdate,
    UsergroupExceptions,
    UsergroupStore,
    UsergroupUpdate,
    UsergroupUpdateHash,
    UsergroupTaxExeptions,
    UserRedeem,
    UserUpdate,
}
